import { coaches } from './coaches'

export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar: string
}

/**
 * SAMPLE COPY — draft quotes written in the buyer's own language (VOC) to
 * show the angle each review should cover. Replace every quote with a real,
 * verifiable buyer review before launch (FTC + Meta ad review).
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      '[Sample] Sunday nights were for inventing next week’s class. Now I open the volume, pick the session and go. The game block alone fixed my queue problem.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
  {
    quote:
      '[Sample] I had two students who couldn’t do the kong. The regression path gave them a real way in instead of standing on the side watching.',
    author: coaches[1].name,
    role: coaches[1].role,
    avatar: coaches[1].avatar,
  },
  {
    quote:
      '[Sample] I coach in a school hall with two benches and some mats. The no-gear variants mean I can run the sessions exactly as written.',
    author: coaches[2].name,
    role: coaches[2].role,
    avatar: coaches[2].avatar,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      '[Sample] The Full-Gym Rotation changed my Saturdays. Twenty kids, four stations, and nobody standing in line.',
    author: coaches[3].name,
    role: coaches[3].role,
    avatar: coaches[3].avatar,
  },
  {
    quote:
      '[Sample] Mixed levels were my biggest headache. Same drill, three levels at once — my beginners and my strongest teens finally work in the same class.',
    author: coaches[4].name,
    role: coaches[4].role,
    avatar: coaches[4].avatar,
  },
  {
    quote:
      '[Sample] I used the year planner to map my after-school club for the whole school year in one evening.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
]
